module.exports = __webpack_public_path__ + "img/history.dc8eebce.png";